import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'api/axiosBaseQuery'

const ipBlocksApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL ?? ''
  }),
  reducerPath: 'ipBlocksApi',
  tagTypes: ['IpBlock'],
  endpoints: () => ({})
})

export default ipBlocksApi
